import { Alert, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { customRequest } from '../../../../common/request/customRequest';
import { STATUS_CODE } from '../../../../common/constants/statusCode';

export const QRMonitoringAddLabelModal = (props: { composeId: string, onFinish: any }) => {

	const [form] = Form.useForm();
	const { projectGroup } = useAuth();
	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	const onFormFinish = async (values: any) => {
		setErrorMessage(null);
		const response = await customRequest(
			`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${props.composeId}/card`,
			{ method: 'POST', data: values }
		);
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {
			setErrorMessage(response.message);
		} else {
			props.onFinish();
		}
	};

	return (
		<Modal open={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>
			<h2>Añadir tarjeta</h2>
			<Form layout='vertical' form={form} onFinish={onFormFinish} style={{ padding: '20px' }}>
				<Form.Item
					rules={[{ required: true, message: 'Por favor, ingrese el empleado' }]}
					name='employee'
					label='Nombre del Empleado'
				>
					<Input />
				</Form.Item>
			</Form>
			{errorMessage && (
				<Alert type='error' message={errorMessage} banner />
			)}
		</Modal>
	);
};
